module.exports = __webpack_public_path__ + "static/media/temp-program-3.06120c66.jpg";